export const PRODUCT_TAGS = {
  // @i18n-ignore
  SOLD_OUT: 'Sold Out',
}
